module.exports = require("react-dimensions");


/*****************
 ** WEBPACK FOOTER
 ** external "react-dimensions"
 ** module id = 108
 ** module chunks = 0
 **/